export enum ClaimsFileType {
  PatientCard = 1,
  HospitalStatement = 2,
  MedicalAidCard = 3,
  Receipts = 5,
  LetterOfAdmissionAndDischarge = 6,
  NationalId = 7
}
